import { render, staticRenderFns } from "./profile-create-associate-modal.vue?vue&type=template&id=72115116&scoped=true&"
import script from "./profile-create-associate-modal.vue?vue&type=script&lang=js&"
export * from "./profile-create-associate-modal.vue?vue&type=script&lang=js&"
import style0 from "./profile-create-associate-modal.vue?vue&type=style&index=0&id=72115116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72115116",
  null
  
)

export default component.exports